import { render, staticRenderFns } from "./PlotStatistic.vue?vue&type=template&id=2958e63c"
import script from "./PlotStatistic.vue?vue&type=script&lang=js"
export * from "./PlotStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports